import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ErrorResponse,
  SendChangePasswordCodeResponse,
  sendChangePasswordResetCodeResponseSchema,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPISendChangePasswordResetCode = (
  options?: UseMutationOptions<SendChangePasswordCodeResponse, ErrorResponse>
) =>
  useMutation({
    mutationFn: () =>
      post(
        API_ENDPOINTS.SEND_PASSWORD_RESET_CODE,
        {},
        sendChangePasswordResetCodeResponseSchema
      ),
    ...options,
  })
